import { api } from "@api";
import {
  createMutation,
  createQuery,
  useQueryClient,
} from "@tanstack/solid-query";

type EventSeasonQuery = Awaited<
  ReturnType<ReturnType<(typeof api)["eventSeasons"]["byId"]>["get"]>
>;

type PublicEventSeasonQuery = Awaited<
  ReturnType<typeof api.eventSeasons.getRecent>
>;

export const createPublicEventSeasonQuery = () => {
  return createQuery<PublicEventSeasonQuery>({
    queryKey: () => ["recent-event-seasons"],
    queryFn: async () => {
      return api.eventSeasons.getRecent();
    },
  });
};

export const createEventSeasonQuery = (details: { seasonId: number }) => {
  return createQuery<EventSeasonQuery>({
    queryKey: () => ["event-season", details.seasonId],
    queryFn: async () => {
      return api.eventSeasons.byId(details.seasonId).get();
    },
  });
};

export const createEventSeasonMutation = (details: { seasonId: number }) => {
  const client = useQueryClient();
  return createMutation({
    mutationFn: async (
      input: Parameters<
        ReturnType<(typeof api)["eventSeasons"]["byId"]>["update"]
      >[0]
    ) => {
      return api.events.byId(details.seasonId).update(input);
    },
    onSuccess: (_, input) => {
      client.setQueryData<EventSeasonQuery>(
        ["event-season", details.seasonId],
        (old) => {
          if (!old) return old;
          return {
            ...old,
            ...input,
            startTime: input.startTime?.toString() ?? old.startTime,
            endTime: input.endTime?.toString() ?? old.endTime,
          };
        }
      );
    },
  });
};

export const createAdminUpcomingEventSeasonsQuery = () => {
  return createQuery({
    queryKey: () => ["admin", "event-seasons", "upcoming"],
    queryFn: async () => await api.eventSeasons.admin.getCurrent({}),
  });
};
